import { makeStyles } from '@material-ui/styles'
import SelectableCard from 'pf9-ui-components/built/components/SelectableCard'
import Radio from 'pf9-ui-components/built/elements/input/Radio'
import Theme from 'pf9-ui-components/built/theme-manager/themes/model'
import React from 'react'
import Text from 'core/elements/Text'

export default function DatabaseCard({ id, onClick, active, title, description, logo }) {
  const classes = useStyles()

  return (
    <div className={classes.cardWrapper}>
      <SelectableCard
        id={id}
        onClick={onClick}
        active={active}
        className={classes.card}
        withCustomBody
      >
        <div className={classes.cardBody}>
          <Radio checked={active} />
          <img src={logo} className={classes.logo} />
          <div>
            <Text variant="caption1">{title}</Text>
            <Text variant="body2">{description}</Text>
          </div>
        </div>
      </SelectableCard>
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  cardWrapper: {
    position: 'relative',
    width: '452px',
    // height: '150px',
  },
  card: {
    width: '100%',
    height: '100%',
  },
  cardBody: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content 1fr',
    gridGap: theme.spacing(1),
    padding: '16px',
    alignItems: 'center',
  },
  logo: {
    width: '146px',
    marginRight: theme.spacing(2),
  },
}))
